{
  "Clear search": "Tøm søk"
}
